import React from 'react'
import VisibleLeafProblemContent from '../containers/VisibleLeafProblemContent'
import VisibleTopicProblemSolutions from '../containers/VisibleTopicProblemSolutions'
import {UniLink, TertiaryButtonDark} from '../../../core/components/unilink/index'
import './topicProblemPage.css'

const TopicProblemPage = ({topic, problemId, problems, createProblem, createSolution, editProblemTopicTags, isLoggedIn, isModerator}) => {
  const index = problems.map((p)=>{return parseInt(p.id)}).indexOf(parseInt(problemId))
  return (
    <div className='topic-problem'>
      
      <div className='gridcontainer topic-problem__container'>
        <h3 className='topic-problem__head'>
          <b>Problem {index+1} of {problems.length}</b>
        </h3>
        <div className='topic-problem__columns'>
          <div className='topic-problem__content'>
            <VisibleLeafProblemContent as='leafProblem' topicId={topic.id} />
            <VisibleTopicProblemSolutions problemId={problemId} topicId={topic.id} />
          </div>
          <div className='topic-problem__sidebar'>
            <h3 className='topic-problem__head'>
              <b>More like this</b>
            </h3>
            { isLoggedIn && isModerator ?
              (
                <div className='topic-problem__links'>
                  <UniLink 
                    to={ '/dashboard/' + topic.id + '/problems' }>
                      View Problems
                  </UniLink>
                  <UniLink to={topic.slug}>View explanations</UniLink>
              
                  <UniLink onClick={editProblemTopicTags}>Edit topic tags</UniLink>
                  <UniLink to={ '/editor/create/problem_solution/' + problemId }>Add a solution</UniLink>
                  <UniLink to={ '/editor/create/problem/' + topic.id }>Create a problem</UniLink>
                  <UniLink to={ '/editor/create/explanation/' + topic.id }>Create an explanation</UniLink>
                  <UniLink 
                    href={ 'https://v1.expii.com/t/' + topic.id + '?type=problem'}>
                      View in V1
                  </UniLink>
                  
                </div>
              )
              : 
              <div className='topic-problem__links'>
                <UniLink to={topic.slug}>View explanations</UniLink>
              </div>
            }
           
            <div className='topic-problem__buttons'>
              <TertiaryButtonDark
                to={index > 0 ? `${topic.slug}?type=problem&id=${problems[index-1].id}`: `${topic.slug}?type=problem&id=${problems[problems.length-1].id}`}
                // disabled={index === 0}
              >
                Previous Problem
              </TertiaryButtonDark>
              <TertiaryButtonDark
                to={index < problems.length-1 ? `${topic.slug}?type=problem&id=${problems[index+1].id}` : `${topic.slug}?type=problem&id=${problems[0].id}`}
                // disabled={index === problems.length-1}
              >
                Next Problem
              </TertiaryButtonDark>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default TopicProblemPage



// WEBPACK FOOTER //
// ./src/domains/topic/components/TopicProblemPage.js